import React, { useState, useEffect } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { useQuery, useMutation } from 'react-apollo-hooks';
import classNames from 'classnames';
import Select from 'react-select';

import BaseModal from '../../components/modals/BaseModal';
import AddTagModal from '../../components/modals/AddTagModal';
import EditTagModal from '../../components/modals/EditTagModal';

import TagCard from '../../components/TagCard';

const TAGS_QUERY = gql`
  query {
    tags {
      id
      name
      qaCount
    }
  }
`;

const Tags = props => {
  const [state, setState] = useState({
    modals: {
      addTag: false,
      editTag: false
    }
  });

  const { loading, error, data, refetch } = useQuery(TAGS_QUERY, {
    fetchPolicy: 'cache-then-network',
    notifyOnNetworkStatusChange: true
  });

  useEffect(() => {
    refetch();
  }, [state.modals.editTag, state.modals.addTag]);

  if (error) {
    return null;
  }

  if (loading && !data) {
    return (
      <div className="tags">
        <div className="tags-header">
          <div className="tags-header-title">Tagit</div>
        </div>
      </div>
    );
  }

  const showAddTagModal = e => {
    e.preventDefault();

    setState(state => ({
      modals: {
        ...state.modals,
        addTag: true
      }
    }));
  };

  const hideAddTagModal = () => {
    setState(state => ({
      modals: {
        ...state.modals,
        addTag: false
      }
    }));
  };

  const showEditTagModal = (id, callback) => e => {
    e.preventDefault();

    setState(state => ({
      modals: {
        ...state.modals,
        editTag: id
      }
    }));
  };

  const hideEditTagModal = () => {
    setState(state => ({
      modals: {
        ...state.modals,
        editTag: false
      }
    }));
  };

  return (
    <div className="tags">
      <div className="tags-header">
        <div className="tags-header-title">Tagit</div>
        <div className="tags-header-actions">
          <div className="tags-header-action" onClick={showAddTagModal}>
            Lisää Tagi
          </div>
        </div>
      </div>
      <div className="tags-items">
        <div className="tags-items-grid">
          {data &&
            data.tags &&
            data.tags
              .sort((a, b) => a.id - b.id)
              .map(tag => (
                <TagCard
                  key={tag.id}
                  {...tag}
                  onClick={showEditTagModal(tag.id)}
                />
              ))}
        </div>
      </div>
      {state.modals.addTag && (
        <BaseModal maxWidth={576} minWidth={340}>
          <AddTagModal closeModal={hideAddTagModal} />
        </BaseModal>
      )}
      {state.modals.editTag && (
        <BaseModal maxWidth={576} minWidth={340}>
          <EditTagModal
            id={state.modals.editTag}
            closeModal={hideEditTagModal}
          />
        </BaseModal>
      )}
    </div>
  );
};

export default Tags;
